<template>
  <section class="sectioncontrol" :class="{'contdatacss': contdatatheme==='contdatacss'}">
    <div class="container">
      <div class="row align-items-start confrow">
          <img :src="contdata.contimage" class="sectionimage">
          <div class="col ">
              <div class="boxdata">
                  <div  class="slide-info shadow">
                      <div  class="spantext">
                          <p v-html="contdata.contshortdesc" class="gradient-text" style="font-weight: bold; font-size: 24px; color: #003"></p>
                          <p v-html="contdata.contdesc" class="desctext" ></p>
                          <p><router-link :to="{path: contdata.contlink}" class="linktextnew">{{ contdata.contlinkname }} <i class="fa-solid fa-square-arrow-up-right linkarrow"></i></router-link></p>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
      
  </section>
  
      </template>
      
      <script>
   
      export default {
        props: ['contdata', 'contdatatheme'],
          data() {
              return {
      
              }
          },
        
      }
      </script>
      
  <style scoped>
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #003;
  }
  .newslearnmore {
      float: right; 
      padding-right: 30px;
  }
  .sectioncontrol {
       height: 100%;
       margin-top: 50px;
       margin-bottom: 40px;
  }
  .sectionimage {
      height: 100%;
      width: 100%;
      z-index: 1;
  }
  .boxdata{
      position: relative;
      width: 380px;
      height: auto;
      margin-top: -280px;
      margin-right: 50px;
      float: right;
      border: solid orange thick;
      z-index: 1;
  }
  .slide-info {
      background-color: white;
    
      margin-top: 10px;
      margin-left: -20px;
      width: 380px;
      height: auto;
      border-radius: 5px;
  }
  .spantext {
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 20px;
      padding-bottom: 20px;
      
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;
    color: orangered;
  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
    color: orangered;
  }
  .linktextnew {
    color: orangered;
    text-decoration: none;
    font-weight: bold;
    padding-left: 150px;
  }
  /*
  .gradient-text {
    font-size: 38px;
    width: 100%;
    background: -webkit-linear-gradient(#004, #003);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
  }*/
  .desctext{
      font-size: 20px;
  }
 
  .sectioncontrol {
    margin-top: -20px;
}
.slide-info {
    background-color: white;
    position: relative;
    margin-top: 10px;
    margin-left: 10px;

    width: 350px;
    height: auto;
    border-radius: 5px;
}
.boxdata{
    position: relative;
    width: 350px;
    height: auto;
    margin-top: -30px;
    margin-left: 40px;

    float: left;
    border: solid orange thick;
    z-index: 1;
}
.sectionimage {
    height: 200px;
    width: 100%;
    z-index: 1;
}


/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
    .boxdata{
        position: relative;
        margin-left: 14px;
        width: 400px;
        height: auto;
        margin-top: 30px;
    }
    .slide-info {
        margin-left: 10px;
        width: 400px;
        height: auto;
        margin-bottom: 10px;
        

    }
 }

@media only screen and (max-width: 360px) {
    .boxdata{
        position: relative;
        margin-left: 14px;
        width: 300px;
        height: auto;
        margin-top: 30px;
    }
    .slide-info {
        margin-left: 10px;
        width: 280px;
        height: auto;
        margin-bottom: 10px;
        

    }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
    .sectioncontrol {
        margin-top: 20px;
    }
    .slide-info {
        background-color: white;
        position: relative;
        margin-top: 10px;
        margin-left: 10px;
    
        width: 350px;
        height: auto;
        border-radius: 5px;
    }
    .boxdata{
        position: relative;
        width: 350px;
        height: auto;
        margin-top: -30px;
        margin-left: 180px;
        padding-bottom: 20px;
        float: left;
        border: solid orange thick;
        z-index: 1;
    }
    .sectionimage {
        height: 200px;
        width: 100%;
        z-index: 1;
    }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
    .slide-info {
        background-color: white;
        position: relative;
        margin-top: 10px;
        margin-left: 0px;
        width: 350px;
        height: auto;
        border-radius: 5px;
    }
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
    .slide-info {
        background-color: white;
        position: relative;
        margin-top: 10px;
        margin-left: -20px;
        width: 350px;
        height: auto;
        border-radius: 5px;
    }
    .sectionimage {
        height: 300px;
        width: 100%;
        z-index: 1;
    }
    .boxdata{ 
        margin-top: -130px;
        float: right;
    }

 } 
  </style>